import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { concatMap, firstValueFrom } from 'rxjs';
import { HeadersService } from './api/headers/headers.service';
import { ContactReference, DbContactReference } from '../../models/reference';
import { ImpacterCountersService } from './impacter-counters.service';


interface DbSearchContactsResponse {
  contacts: Array<DbContactReference>;
  error?: string;
}

interface SearchContactsResponse {
  contacts: Array<ContactReference>;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  constructor(private http: HttpClient, private headersService: HeadersService,
              private impacterCountersService: ImpacterCountersService) { }

  search_contacts(territory_uid: string, use_cache_only: boolean = false): Promise<SearchContactsResponse> {
    return firstValueFrom(this.http.post<DbSearchContactsResponse>(
      environment.explainApiGatewayUrl + 'search-contacts',
      {
        territory_uid: territory_uid,
        action: use_cache_only ? 'check_cache' : 'search_contacts',
      },
      {
        ...this.headersService.httpHeaders,
        responseType: 'json'
      }
    ).pipe(concatMap(async res => {
      return {
        contacts: await Promise.all(res.contacts.map(async (contact, index) => {
          const territory = contact.id ?
            await this.impacterCountersService.getImpacterReferenceTerritory(contact.id, contact.departments_uids) : undefined;
          return new ContactReference(contact, territory?.uid, territory?.articleCount);
        })),
        error: res.error
      };
    })));
  }
}
